export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6631.02679ea0.jpg";